import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';

// PrimeNG Modules
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { DropdownModule } from 'primeng/dropdown';
import { TagModule } from 'primeng/tag';
import { SkeletonModule } from 'primeng/skeleton';
import { MessageService } from 'primeng/api';

import { OnlineHomeComponent } from './online-home/online-home.component';
import { OnlineRegistrationModule } from './online-registration/online-registration.module';
import { SchoolService } from '../../services/school/school.service';
import { OnlineRegistrationComponent } from './online-registration/online-registration.component';

const routes: Routes = [
  {
    path: 'online',
    pathMatch: 'full',
    component: OnlineHomeComponent
  },
  {
    path: 'online/:slug',
    pathMatch: 'full',
    component: OnlineRegistrationComponent
  },
];

@NgModule({
  declarations: [
    OnlineHomeComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    TranslateModule,
    RouterModule.forChild(routes),
    
    // PrimeNG Modules
    ButtonModule,
    InputTextModule,
    DropdownModule,
    TagModule,
    SkeletonModule,
    
    // Other Modules
    OnlineRegistrationModule
  ],
  providers: [
    MessageService,
    SchoolService
  ]
})
export class OnlineAccessModule { }
